'use strict';
var fireOnLoad = function (callback) {
    // @ts-ignore
    if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
        callback();
    }
    else {
        // @ts-ignore
        document.addEventListener('DOMContentLoaded', callback);
    }
};
var fireOnVisible = function (duration, selector, callback) {
    if (document.querySelectorAll(selector).length > 0) {
        callback();
    }
    var intervalId = setInterval(function () {
        if (document.querySelectorAll(selector).length > 0) {
            clearInterval(intervalId);
            callback();
        }
    }, duration);
};
var fireOnMutated = function (targetSelector, callback) {
    if (!('MutationObserver' in window)) {
        return; // MutationObserver not available
    }
    var targetNodes = document.querySelectorAll(targetSelector);
    // @ts-ignore
    var observer = new MutationObserver(callback);
    var observerConfig = { attributes: false, childList: true, subtree: true };
    targetNodes.forEach(function (target) {
        observer.observe(target, observerConfig);
    });
};
export default {
    bind: function (strategy, callback) {
        if (strategy === undefined || strategy.type === undefined || strategy.type === 'onload') {
            fireOnLoad(callback);
        }
        else if (strategy.type === 'interval') {
            var intervalDuration = strategy.duration || 250;
            var selector = strategy.waitForElem;
            fireOnVisible(intervalDuration, selector, callback);
        }
        else if (strategy.type === 'observer') {
            fireOnLoad(callback); // initialize first
            fireOnMutated(strategy.wrapper, callback); // and observer changes to reinit
        }
    }
};
